export const STORE_INVOICE_LABELS = {
  pageTitle: "Consulta NFe",
  pageDescription: "Consulte as notas fiscais emitidas por loja e período",
  storeLabel: "Loja",
  storePlaceholder: "Selecione a loja",
  periodLabel: "Período",
  periodPlaceholder: "Selecione o período",
  invoiceStatusLabel: "Situação da nota",
  saleStatusLabel: "Situação da venda",
  documentTypeLabel: "Tipo de nota",
  seriesLabel: "Série",
  seriesPlaceholder: "Ex.: 033",
  allOption: "Todas",
  searchButton: "Consultar",
  excelButton: "Gerar Excel",
  generating: "Gerando…",
  searching: "Consultando…",
  selectFiltersHint: "Selecione a loja e o período para consultar",
  emptyResult: "Nenhuma nota encontrada para os filtros selecionados",
  totalLabel: "notas encontradas",
  pageSizeLabel: "Linhas por página",
  previousPage: "Anterior",
  nextPage: "Próximo",
  invoiceSingular: "nota",
  invoicePlural: "notas",
} as const;

export const PAGE_SIZE_OPTIONS: readonly number[] = [10, 20, 50, 100];

export enum InvoiceStatus {
  SEM_EMISSAO = 0,
  AUTORIZADA = 2,
  CONTINGENCIA = 3,
  CANCELADA = 9,
}

export enum SaleStatus {
  VALIDA = 0,
  CANCELADA = 9,
}

export enum DocumentType {
  SEM_DOCUMENTO_FISCAL = 0,
  NFCE = 2,
  NFCE_E_NFE = 3,
  NFE = 6,
}

export interface FilterOption {
  readonly value: string;
  readonly label: string;
}

export const INVOICE_STATUS_OPTIONS: readonly FilterOption[] = [
  { value: String(InvoiceStatus.SEM_EMISSAO), label: "Sem emissão" },
  { value: String(InvoiceStatus.AUTORIZADA), label: "Autorizada" },
  { value: String(InvoiceStatus.CONTINGENCIA), label: "Contingência" },
  { value: String(InvoiceStatus.CANCELADA), label: "Cancelada" },
];

export const SALE_STATUS_OPTIONS: readonly FilterOption[] = [
  { value: String(SaleStatus.VALIDA), label: "Válida" },
  { value: String(SaleStatus.CANCELADA), label: "Cancelada" },
];

export const DOCUMENT_TYPE_OPTIONS: readonly FilterOption[] = [
  {
    value: String(DocumentType.SEM_DOCUMENTO_FISCAL),
    label: "Sem documento fiscal",
  },
  { value: String(DocumentType.NFCE), label: "NFC-e" },
  { value: String(DocumentType.NFCE_E_NFE), label: "NFC-e + NF-e" },
  { value: String(DocumentType.NFE), label: "NF-e" },
];

export const MAX_PERIOD_DAYS = 31;

export const GLOBALLY_HANDLED_STATUS: ReadonlySet<number> = new Set([
  401, 403, 423,
]);

export const STORE_INVOICE_MESSAGES = {
  MISSING_FILTERS: {
    description: "Selecione a loja e o período antes de consultar",
    variant: "destructive" as const,
  },
  PERIOD_TOO_LONG: {
    description: `O período não pode ultrapassar ${MAX_PERIOD_DAYS} dias`,
    variant: "destructive" as const,
  },
  EMPTY_EXPORT: {
    description: "Nenhuma nota para exportar no período selecionado",
  },
  EXPORT_QUEUED: {
    description:
      "Estamos gerando sua exportação. Ela chegará em {email} e nas suas notificações.",
  },
  EXPORT_ERROR: {
    description: "Não foi possível gerar o Excel",
    variant: "destructive" as const,
  },
};

export const EMAIL_PLACEHOLDER = "{email}";

export const EXCHANGE_WINDOW_WARNING =
  "A loja não guarda trocas anteriores a {date}. Notas antes dessa data podem aparecer como não usadas em troca mesmo tendo sido.";

export const PERIOD_BUTTON_CLASS =
  "h-8 w-56 px-3 py-1 text-xs bg-white hover:bg-white text-slate-900 " +
  "border-solid border border-[#d1d5db] hover:border-[#f4c83e]";

export const STORE_INVOICE_FILE_PREFIX = "consulta-nfe";
export const EXCEL_EXTENSION = "xlsx";
export const DEFAULT_PER_PAGE = 50;
export const FIRST_PAGE = 1;
export const DATE_FORMAT = "yyyy-MM-dd";
export const ISO_DATE_LENGTH = 10;
export const DISPLAY_DATE_FORMAT = "dd/MM/yyyy";
export const EXCHANGE_YES = "Sim";
export const EXCHANGE_NO = "Não";
export const EMPTY_CELL = "-";
